export default __webpack_public_path__ + "static/media/warning--opening-or-swing-bridge--g2.1a1a0f21.png";